// German translations
const de = {
    translation: {
        // Common
        'app.name': 'Visuelle Fernüberwachung',
        'app.login': 'Anmelden',
        'app.loginDemo': 'Demo Anmelden',
        'app.register': 'Registrieren',
        'app.logout': 'Abmelden',
        'common.dashboard': 'Dashboard',
        'common.installations': 'Installationsliste',
        'app.news': 'News',
        'news.overview': 'News-Übersicht',
        'news.searchPlaceholder': 'Neuigkeiten suchen...',
        'news.searchButton': 'Suchen',
        'news.noNewsFound': 'Keine Neuigkeiten gefunden.',
        'app.shop': 'Shop',

        // Gallery
        'gallery.title': 'Installationsgalerie',
        'gallery.share': 'Teilen',
        'gallery.shared': 'Geteilt',
        'gallery.pending': 'Prüfung ausstehend',
        'gallery.noImages': 'Keine Bilder verfügbar',
        'gallery.like': 'Gefällt mir',
        'gallery.loginToLike': 'Zum Liken anmelden',
        'gallery.loadError': 'Galerie-Ladefehler',
        'common.uploadImagesSuccess': 'Upload erfolgreich',
        'common.uploadImagesFailed': 'Upload fehlgeschlagen',
        'gallery.deleteConfirm': 'Dieses Bild wirklich löschen?',
        'gallery.maxImages': 'Maximal {{max}} Bilder erlaubt',
        'gallery.caption': 'Bildbeschreibung',
        'gallery.selectInstallation': 'Installation wählen',
        'gallery.selectFiles': 'Bilder auswählen',
        'gallery.filesSelected': '{{count}} Dateien gewählt',
        'gallery.selectInstallationAndFiles': 'Installation und Bilder wählen',
        'gallery.shareToGallery': 'In Galerie teilen',
        'gallery.myImages': 'Meine Bilder',
        'gallery.publicGallery': 'Öffentliche Galerie',
        'gallery.unshare': 'Löschen (Teilen)',
        'gallery.unshared': 'Nicht geteilt',
        'gallery.subtitle': 'Teilen Sie Ihre Solarinstallation',
        'gallery.dropOrClick': 'Bilder hierher ziehen',
        'gallery.private': 'Privat',
        'gallery.selectSource': 'Bildquelle wählen',
        'gallery.takePhoto': 'Foto aufnehmen',
        'gallery.chooseFromGallery': 'Aus Galerie wählen',
        'gallery.captionPlaceholder': 'Beschreibung hinzufügen...',
        'gallery.shareHint': 'Anderen dieses Foto zeigen',
        'common.uploadImagesHint': 'JPG, PNG (max. 10MB)',

        'common.devices': 'Geräte',
        'app.profile': 'Profil',
        'common.settings': 'Einstellungen',
        'settings.verificationCode': 'Bestätigungscode',
        'settings.sendCode': 'Code senden',
        'settings.codeSentNotice': 'Bestätigungscode an Ihre E-Mail gesendet',
        'settings.codeRequired': 'Bitte geben Sie den 6-stelligen Code ein',
        'app.language': 'Sprache',
        'app.email': 'E-Mail',
        'common.password': 'Passwort',
        'app.username': 'Benutzername',
        'app.confirmPassword': 'Passwort bestätigen',
        'app.submit': 'Senden',
        'common.cancel': 'Abbrechen',
        'common.save': 'Speichern',
        'common.set': 'Senden',
        'common.delete': 'Löschen',
        'common.add': 'Hinzufügen',
        'common.upload': 'Hochladen',
        'common.edit': 'Bearbeiten',
        'common.search': 'Suchen',
        'common.filter': 'Filter',
        'common.sort': 'Sortieren',
        'common.status': 'Status',
        'common.online': 'Online',
        'common.offline': 'Offline',
        'common.error': 'Fehler',
        'common.success': 'Erfolg',
        'app.back': 'Zurück',
        'app.home': 'Home',
        'common.actions': 'Aktionen',
        'common.loading': 'Lädt...',
        'common.processing': 'Verarbeitung...',
        'common.close': 'Schließen',
        'common.units': 'Einheiten',
        'common.normal': 'Normal',
        'common.tooHigh': 'Zu hoch',
        'common.tooLow': 'Zu niedrig',
        'common.number': 'Nummer',
        'common.time': 'Zeit',
        'common.overview': 'Übersicht',
        'common.details': 'Details',
        'common.rowsPerPage': 'Zeilen pro Seite',
        'common.readMore': 'Weiterlesen',
        // Unified terms
        'common.voltage': 'Spannung',
        'common.current': 'Strom',
        'common.power': 'Leistung',
        'common.temperature': 'Temperatur',
        'common.soc': 'SOC',
        'common.charging': 'Laden',
        'common.discharging': 'Entladen',
        'common.idle': 'Standby',
        'common.warning': 'Warnung',
        'common.warnState1': 'Warnungsstatus 1',
        'common.warnState2': 'Warnungsstatus 2',
        'common.cell': 'Zelle',
        'common.avgVoltage': 'Durchschnittsspannung',
        'common.avgTemperature': 'Durchschnittstemp.',
        'common.totalCurrent': 'Gesamtstrom',
        'common.totalPower': 'Gesamtleistung',
        'common.fullyCharged': 'Voll geladen',
        'common.user': 'Benutzer',
        'common.deviceId': 'Geräte-ID',
        'common.unknownWarning': 'Unbekannte Warnung',
        'common.admin': 'Admin',
        'common.protection': 'Schutz',
        'common.fault': 'Fehler',
        'common.calibration': 'Kalibrierung',
        'common.refresh': 'Aktualisieren',
        'common.addDevice': 'Gerät hinzufügen',
        'common.deviceAdded': 'Gerät hinzugefügt',
        'common.cycleCount': 'Zyklenzahl',
        'common.soh': 'SOH',
        'common.realtime': 'Echtzeit-Monitoring',
        'common.batteryPackTitle': 'Batteriepack #{{index}}',
        'common.remainCapacityAh': 'Restkapazität (Ah)',
        'common.fullChargeCapacityAh': 'Vollkapazität (Ah)',
        'common.designCapacityAh': 'Nennkapazität (Ah)',
        'common.backToDetail': 'Zurück zum Detail',
        'common.loadDeviceFailed': 'Geräteladefehler',
        'common.permissionsManagement': 'Rechteverwaltung',
        'common.shortCircuitProt': 'Kurzschlussschutz',
        'common.startDate': 'Startdatum',
        'common.endDate': 'Enddatum',
        // Status & States
        'common.expired': 'Abgelaufen',
        // Actions
        'common.create': 'Erstellen',
        // Time-related
        'common.day': 'Tag',
        'common.days': 'Tage',
        'common.createdAt': 'Erstellt am',
        'common.expiry': 'Ablaufdatum',
        'common.expiryDays': 'Gültigkeit (Tage)',
        // Battery-related
        'common.batteryPack': 'Batteriepack',
        'common.dischargeEnabled': 'Entladen ein',
        'common.chargeEnabled': 'Laden ein',
        'common.currentLimit': 'Strombegrenzung',
        'common.charger': 'Ladegerät',
        'common.avg': 'Mittelw.',

        // Device
        'device.lastConnection': 'Letzte Verbindung',
        'device.delete': 'Installation löschen',
        'device.view': 'Gerät anzeigen',
        'device.notFound': 'Gerät nicht gefunden',
        'device.deleteSuccess': 'Installation gelöscht',
        'device.confirmDelete': 'Diese Installation wirklich löschen?',
        'device.info': 'Installationsinfo',
        'device.details': 'Gerätedetails',
        'device.never': 'Nie',
        'device.errorMissingFields': 'Felder ausfüllen',
        'device.idHelp': 'Eindeutige ID eingeben',
        'device.nameHelp': 'Gerätenamen eingeben',
        'device.loading': 'Geräte laden...',
        'common.justNow': 'Gerade eben',
        'device.minutesAgo': 'Minuten her',
        'device.hoursAgo': 'Stunden her',
        'device.noDevicesDesc': 'Keine Geräte vorhanden. Klicken Sie auf Hinzufügen.',
        'device.deleting': 'Wird gelöscht...',
        'device.noConnections': 'Keine Verbindungen',
        'device.type': 'Gerätetyp',
        'device.optionalInfo': 'Optionale Informationen',
        'device.optionalInfoTooltip': 'Besonderer Service & Support',
        'device.inverterBrand': 'Wechselrichter-Marke',
        'device.inverterModel': 'Wechselrichter-Modell',
        'device.solarPower': 'Solarleistung (kW)',
        'device.city': 'Stadt',
        'device.description': 'Beschreibung',
        'device.updatedAt': 'Aktualisiert am',

        // Battery data
        'battery.status': 'Ladestatus',
        'battery.data': 'Batteriedaten',
        'battery.history': 'Verlauf',
        'battery.protectionRecord': 'Schutz-Log',
        'battery.from': 'Von',
        'battery.to': 'Bis',
        'battery.noData': 'Keine Daten',
        'battery.historyCharts': 'Verlaufscharts',
        'battery.resetZoom': 'Reset',

        'battery.cellData': 'Zelldaten',
        'battery.cellVoltageData': 'Zellspannungen',
        'battery.temperatureData': 'Sensortemperaturen',
        'battery.cellDataUnavailable': 'Zelldaten nicht verfügbar...',
        'battery.tempDataUnavailable': 'Temperaturdaten nicht verfügbar...',
        'battery.cellVoltageTable': 'Zellspannungstabelle',
        'battery.tempDataTable': 'Sensortabelle',
        'battery.cellStats': 'Zellstatistik',
        'battery.activeBalancing': 'Aktives Balancing',
        'battery.balance': 'Balance Current',
        'battery.activeBalancingOn': 'Balancing',
        'battery.highest': 'Höchste',
        'battery.lowest': 'Niedrigste',
        'battery.highestVoltage': 'Höchste Spannung',
        'battery.lowestVoltage': 'Niedrigste Spannung',
        'battery.volDiff': 'Spannungsdifferenz',
        'battery.totalCells': 'Gesamtzellen',
        'battery.temperatureSensors': 'Temperatursensoren',
        'battery.temperatureStats': 'Temperaturstatistik',
        'battery.sensorCount': 'Sensoranzahl',
        'battery.highestTemperature': 'Höchste Temperatur',
        'battery.lowestTemperature': 'Niedrigste Temperatur',
        'battery.faultState': 'Fehlerstatus',
        'battery.protectState1': 'Schutzstatus 1',
        'battery.protectState2': 'Schutzstatus 2',

        // Warning titles
        'warning.title': 'Warnmeldungen',
        'warning.current': 'Aktuelle Warnungen',
        'warning.normal': 'Status normal, keine Warnungen',
        'warning.noWarning': 'Keine Warnung',

        // Protection state related
        'warning.protect_high_discharge_current': 'Überstromschutz (Entladen)',
        'warning.protect_high_charge_current': 'Überstromschutz (Laden)',
        'warning.protect_low_total_voltage': 'Gesamt-Unterspannungsschutz',
        'warning.protect_high_total_voltage': 'Gesamt-Überspannungsschutz',
        'warning.protect_low_cell_voltage': 'Einzelzell-Unterspannungsschutz',
        'warning.protect_high_cell_voltage': 'Einzelzell-Überspannungsschutz',
        'warning.protect_low_env_temp': 'Umgebungs-Tieftemperaturschutz',
        'warning.protect_high_env_temp': 'Umgebungs-Hochtemperaturschutz',
        'warning.protect_high_mos_temp': 'MOS-Hochtemperaturschutz',
        'warning.protect_low_discharge_temp': 'Entlade-Tieftemperaturschutz',
        'warning.protect_low_charge_temp': 'Lade-Tieftemperaturschutz',
        'warning.protect_high_discharge_temp': 'Entlade-Hochtemperaturschutz',
        'warning.protect_high_charge_temp': 'Lade-Hochtemperaturschutz',

        // Command state related
        'battery.reverse_connected': 'Verpolungsschutz',

        // Fault state related
        'warning.fault_sampling': 'Abtastfehler',
        'warning.fault_cell': 'Zellfehler',
        'warning.fault_ntc': 'Sensorfehler',
        'warning.fault_discharge_mos': 'Entlade-MOS Fehler',
        'warning.fault_charge_mos': 'Lade-MOS Fehler',
        'warning.fault_adapter_temp': 'Adapterboard Übertemperatur',
        'warning.fault_virtual_connection': 'Batterie-Kontaktfehler',
        'warning.fault_communication': 'Kommunikationsfehler',
        'warning.fault_ccb': 'CCB-Fehler',
        'warning.fault_heater': 'Heizungsfehler',
        'warning.fault_12v': '12V-Stromfehler',
        'warning.fault_total_voltage': 'Gesamtspannungsfehler',
        'warning.fault_temp_diff': 'Temperaturdifferenzfehler',
        'warning.fault_detect_resistor': 'Erkennungswiderstandsfehler',
        'warning.fault_trip_unit': 'Auslöseeinheit-Fehler',
        'warning.fault_master_slave': 'Master/Slave-Fehler',
        'warning.fault_bms_lock': 'BMS gesperrt',
        'warning.fault_mcu_overvoltage': 'MCU-Überspannung',

        'warning.protect_short_circuit': 'Kurzschlussschutz',
        'warning.protect_charger_overvoltage': 'Ladegerät-Überspannungsschutz',
        'warning.protect_full_charge': 'Vollladungsschutz',

        // Status indicators
        'status.limit_current_on': 'Strombegrenzung EIN',
        'status.limit_current_off': 'Strombegrenzung AUS',
        'status.charge_mos_on': 'Lade-MOS EIN',
        'status.charge_mos_off': 'Lade-MOS AUS',
        'status.discharge_mos_on': 'Entlade-MOS EIN',
        'status.discharge_mos_off': 'Entlade-MOS AUS',
        'status.charger_connected': 'Ladegerät verbunden',
        'status.charger_disconnected': 'Ladegerät getrennt',
        'status.heater_on': 'Heizung EIN',
        'status.heater_off': 'Heizung AUS',

        // Warning state 1 related
        'warning.warn_high_discharge_current': 'Hoher Entladestrom (Warnung)',
        'warning.warn_high_charge_current': 'Hoher Ladestrom (Warnung)',
        'warning.warn_low_total_voltage': 'Niedrige Gesamtspannung (Warnung)',
        'warning.warn_high_total_voltage': 'Hohe Gesamtspannung (Warnung)',
        'warning.warn_low_cell_voltage': 'Niedrige Zellspannung (Warnung)',
        'warning.warn_high_cell_voltage': 'Hohe Zellspannung (Warnung)',

        // Warning state 2 related
        'warning.warn_low_soc': 'Niedriger SOC (Warnung)',
        'warning.warn_high_mos_temp': 'MOS Übertemperatur (Warnung)',
        'warning.warn_low_env_temp': 'Umgebungs-Tieftemperatur (Warnung)',
        'warning.warn_high_env_temp': 'Umgebungs-Hochtemperatur (Warnung)',
        'warning.warn_low_discharge_temp': 'Entlade-Tieftemperatur (Warnung)',
        'warning.warn_low_charge_temp': 'Lade-Tieftemperatur (Warnung)',
        'warning.warn_high_discharge_temp': 'Entlade-Hochtemperatur (Warnung)',
        'warning.warn_high_charge_temp': 'Lade-Hochtemperatur (Warnung)',

        // Warning states
        'warning.below_lower_limit': 'Unter Grenzwert',
        'warning.above_upper_limit': 'Über Grenzwert',
        'warning.user_defined': 'Benutzerdefiniert',
        'warning.other_fault': 'Anderer Fehler',

        // Warning descriptions
        'warningDesc.warn_low_soc': 'Der SOC-Wert der Batterie liegt unter dem sicheren Schwellenwert, bitte laden Sie die Batterie rechtzeitig auf',
        'warningDesc.warn_high_mos_temp': 'Die MOS-Temperatur ist zu hoch, was die Lade-/Entladeeffizienz beeinträchtigen kann',
        'warningDesc.warn_low_env_temp': 'Die Umgebungstemperatur ist zu niedrig, was die Batterieleistung beeinträchtigen kann',
        'warningDesc.warn_high_env_temp': 'Die Umgebungstemperatur ist zu hoch, bitte achten Sie auf eine ausreichende Wärmeabfuhr',
        'warningDesc.warn_low_discharge_temp': 'Die Entladetemperatur ist zu niedrig, der Entladevorgang wurde begrenzt',
        'warningDesc.warn_low_charge_temp': 'Die Ladetemperatur ist zu niedrig, der Ladevorgang wurde begrenzt',
        'warningDesc.warn_high_discharge_temp': 'Die Entladetemperatur ist zu hoch, der Entladevorgang wurde begrenzt',
        'warningDesc.warn_high_charge_temp': 'Die Ladetemperatur ist zu hoch, der Ladevorgang wurde begrenzt',
        'warningDesc.warn_high_discharge_current': 'Der Entladestrom überschreitet das Sicherheitslimit',
        'warningDesc.warn_high_charge_current': 'Der Ladestrom überschreitet das Sicherheitslimit',
        'warningDesc.warn_low_total_voltage': 'Die Gesamtspannung liegt unter dem sicheren Schwellenwert',
        'warningDesc.warn_high_total_voltage': 'Die Gesamtspannung liegt über dem sicheren Schwellenwert',
        'warningDesc.warn_low_cell_voltage': 'Die Zellspannung ist zu niedrig',
        'warningDesc.warn_high_cell_voltage': 'Die Zellspannung ist zu hoch',
        'warningDesc.protect_high_discharge_current': 'Der Entladestrom ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_charge_current': 'Der Ladestrom ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_short_circuit': 'Kurzschluss erkannt, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_low_total_voltage': 'Die Gesamtspannung ist zu niedrig, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_total_voltage': 'Die Gesamtspannung ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_low_cell_voltage': 'Die Zellspannung ist zu niedrig, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_cell_voltage': 'Die Zellspannung ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_low_env_temp': 'Die Umgebungstemperatur ist zu niedrig, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_env_temp': 'Die Umgebungstemperatur ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_mos_temp': 'Die MOS-Temperatur ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_low_discharge_temp': 'Die Entladetemperatur ist zu niedrig, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_low_charge_temp': 'Die Ladetemperatur ist zu niedrig, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_discharge_temp': 'Die Entladetemperatur ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.protect_high_charge_temp': 'Die Ladetemperatur ist zu hoch, Schutzmaßnahme wurde ausgelöst',
        'warningDesc.fault_sampling': 'Der Zell-Abtastschaltkreis ist abnormal, bitte überprüfen Sie die Hardware',
        'warningDesc.fault_cell': 'Zellfehler erkannt, bitte überprüfen Sie das Batteriepack',
        'warningDesc.fault_ntc': 'Temperatursensorfehler, genaue Temperaturmessung nicht möglich',
        'warningDesc.fault_discharge_mos': 'Entlade-MOS-Fehler, normaler Entladevorgang nicht möglich',
        'warningDesc.fault_charge_mos': 'Lade-MOS-Fehler, normaler Ladevorgang nicht möglich',
        'warningDesc.fault_adapter_temp': 'Die Temperatur der Adapterplatine ist zu hoch',
        'warningDesc.fault_virtual_connection': 'Schlechter Batteriekontakt, bitte überprüfen Sie die Verbindungen',

        // Authentication
        'auth.loginTitle': 'Anmelden',
        'auth.registerTitle': 'Konto erstellen',
        'auth.forgotPassword': 'Passwort vergessen?',
        'auth.noAccount': 'Noch kein Konto?',
        'auth.haveAccount': 'Haben Sie ein Konto?',
        'auth.loginSuccess': 'Anmeldung erfolgreich',
        'auth.registerSuccess': 'Registrierung erfolgreich',
        'auth.registerFailed': 'Registrierung fehlgeschlagen',
        'auth.logoutSuccess': 'Abmeldung erfolgreich',
        'auth.invalidCredentials': 'E-Mail oder Passwort falsch',
        'auth.passwordMismatch': 'Passwörter ungleich',
        'auth.emailExists': 'E-Mail existiert bereits',
        'auth.usernameExists': 'Nutzername existiert bereits',
        'auth.managerEmail': 'Admin-E-Mail (optional)',
        'auth.managerEmailHelp': 'Team mit Admin-E-Mail beitreten',
        'auth.invitationCode': 'Einladungscode (optional)',
        'auth.invitationCodeHelp': 'Hier Code eingeben',
        'auth.forgotPasswordDesc': 'Bitte geben Sie Ihre registrierte E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
        'auth.forgotPasswordSuccess': 'E-Mail zum Zurücksetzen gesendet. Bitte prüfen Sie Ihren Posteingang.',
        'auth.invalidToken': 'Ungültiger Token',
        'auth.tokenErrorDesc': 'Ungültiger oder fehlender Token zum Zurücksetzen. Bitte rufen Sie diese Seite über den Link in Ihrer E-Mail auf.',
        'auth.passwordUpdated': 'Passwort erfolgreich zurückgesetzt. Weiterleitung zur Anmeldung...',
        'auth.resetPasswordTitle': 'Passwort zurücksetzen',

        // Settings
        'settings.about': 'Über uns',
        'settings.aboutDesc': 'Home Battery IoT Monitoring System.',
        'settings.languageUpdated': 'Sprache aktualisiert',
        'settings.updateFailed': 'Fehler bei Einstellungen',
        'settings.changePassword': 'Passwort ändern',
        'settings.currentPassword': 'Aktuelles Passwort',
        'settings.newPassword': 'Neues Passwort',
        'settings.confirmPassword': 'Neues PW bestätigen',
        'settings.passwordUpdated': 'Passwort geändert',
        'settings.passwordMismatch': 'PW ungleich',
        'settings.passwordTooShort': 'Min. 6 Zeichen',
        'settings.usernameUpdated': 'Nutzername aktualisiert',
        'settings.appearance': 'Erscheinungsbild',
        'settings.avatar': 'Avatar',
        'settings.changeAvatar': 'Avatar ändern',
        'settings.avatarHint': 'Max. 2MB, JPG/PNG/WebP',
        'settings.avatarUpdated': 'Avatar aktualisiert',
        'settings.invalidFileType': 'Bitte ein Bild wählen',
        'settings.fileTooLarge': 'Datei zu groß (max. 2MB)',
        'settings.timezone': 'Zeitzone',
        'settings.timezoneUpdated': 'Zeitzone aktualisiert',

        // Timezones
        'timezones.UTC': 'UTC (Weltzeit)',
        'timezones.Europe/London': 'London',
        'timezones.Europe/Dublin': 'Dublin',
        'timezones.Europe/Paris': 'Paris',
        'timezones.Europe/Berlin': 'Berlin',
        'timezones.Europe/Amsterdam': 'Amsterdam',
        'timezones.Europe/Brussels': 'Brüssel',
        'timezones.Europe/Rome': 'Rom',
        'timezones.Europe/Madrid': 'Madrid',
        'timezones.Europe/Lisbon': 'Lissabon',
        'timezones.Europe/Vienna': 'Wien',
        'timezones.Europe/Zurich': 'Zürich',
        'timezones.Europe/Stockholm': 'Stockholm',
        'timezones.Europe/Oslo': 'Oslo',
        'timezones.Europe/Copenhagen': 'Kopenhagen',
        'timezones.Europe/Helsinki': 'Helsinki',
        'timezones.Europe/Warsaw': 'Warschau',
        'timezones.Europe/Prague': 'Prag',
        'timezones.Europe/Athens': 'Athen',
        'timezones.Europe/Istanbul': 'Istanbul',
        'timezones.Europe/Moscow': 'Moskau',
        'timezones.America/New_York': 'New York',
        'timezones.America/Toronto': 'Toronto',
        'timezones.America/Chicago': 'Chicago',
        'timezones.America/Denver': 'Denver',
        'timezones.America/Phoenix': 'Phoenix',
        'timezones.America/Los_Angeles': 'Los Angeles',
        'timezones.America/Vancouver': 'Vancouver',
        'timezones.America/Anchorage': 'Anchorage',
        'timezones.Pacific/Honolulu': 'Honolulu',
        'timezones.America/Mexico_City': 'Mexiko-Stadt',
        'timezones.America/Bogota': 'Bogotá',
        'timezones.America/Lima': 'Lima',
        'timezones.America/Santiago': 'Santiago',
        'timezones.America/Sao_Paulo': 'São Paulo',
        'timezones.America/Buenos_Aires': 'Buenos Aires',
        'timezones.Asia/Jerusalem': 'Jerusalem',
        'timezones.Asia/Beirut': 'Beirut',
        'timezones.Asia/Amman': 'Amman',
        'timezones.Asia/Baghdad': 'Bagdad',
        'timezones.Asia/Kuwait': 'Kuwait',
        'timezones.Asia/Dubai': 'Dubai',
        'timezones.Asia/Muscat': 'Muskat',
        'timezones.Asia/Riyadh': 'Riad',
        'timezones.Asia/Qatar': 'Doha',
        'timezones.Asia/Tehran': 'Teheran',
        'timezones.Asia/Kolkata': 'Mumbai / Neu-Delhi',
        'timezones.Asia/Bangkok': 'Bangkok',
        'timezones.Asia/Jakarta': 'Jakarta',
        'timezones.Asia/Singapore': 'Singapur',
        'timezones.Asia/Hong_Kong': 'Hongkong',
        'timezones.Asia/Shanghai': 'Shanghai / Peking',
        'timezones.Asia/Taipei': 'Taipeh',
        'timezones.Asia/Seoul': 'Seoul',
        'timezones.Asia/Tokyo': 'Tokio',
        'timezones.Australia/Sydney': 'Sydney',
        'timezones.Pacific/Auckland': 'Auckland',
        'timezones.Africa/Cairo': 'Kairo',
        'timezones.Africa/Johannesburg': 'Johannesburg',

        'common.uploading': 'Wird hochgeladen...',

        // Errors
        'error.pageNotFound': 'Seite nicht gefunden',
        'error.pageNotFoundDesc': 'Gelöscht, umbenannt oder temporär nicht verfügbar.',
        'error.fetchFailed': 'Datenabruf fehlgeschlagen',
        'error.createFailed': 'Erstellung fehlgeschlagen',
        'error.copyFailed': 'Kopieren fehlgeschlagen',
        'error.processFailed': 'Anfragefehler',

        // Admin
        'admin.dashboard': 'Admin Dashboard',
        'admin.superDashboard': 'Superadmin Dashboard',
        'admin.managedUsers': 'Verwaltete Nutzer',
        'admin.managedDevices': 'Verwaltete Geräte',
        'admin.role': 'Rolle',
        'admin.superadmin': 'Superadmin',
        'admin.noUsers': 'Keine Nutzer gefunden',
        'admin.userList': 'Nutzerliste',
        'admin.adminList': 'Adminliste',
        'admin.deviceList': 'Geräteliste',
        'admin.noAdmins': 'Keine Admins gefunden',
        'admin.addAdmin': 'Admin hinzufügen',
        'admin.createError': 'Fehler bei Admin-Erstellung',
        'admin.fillAllFields': 'Alle Felder ausfüllen',
        'admin.deviceCount': 'Geräteanzahl',
        'admin.assignManager': 'Admin zuweisen',
        'admin.selectManager': 'Wähle Admin',
        'admin.noManager': 'Kein Admin',
        'admin.assigningUser': 'Nutzer wird zugewiesen',
        'admin.assign': 'Zuweisen',
        'admin.assignError': 'Zuweisungsfehler',
        'admin.self': 'Ich',
        'admin.active': 'Aktiv',
        'admin.used': 'Benutzt',
        'admin.adminPanel': 'Admin-Panel',

        'admin.invitationManagement': 'Einladungscodes',
        'admin.createInvitation': 'Code erstellen',
        'admin.invitationCode': 'Einladungscode',
        'admin.invitationCreated': 'Code erstellt',
        'admin.copy': 'Kopieren',
        'admin.codeCopied': 'Kopiert',
        'admin.noInvitations': 'Keine Codes gefunden',

        'user.authRequests': 'Berechtigungsanfragen',
        'user.authRequestManagement': 'Anfragemanagement',
        'user.createAuthRequest': 'Anfrage erstellen',
        'user.authCode': 'Autorisierungscode',
        'user.authRequestCreated': 'Anfrage erstellt',
        'user.shareAuthLink': 'Link teilen',
        'user.shareAuthLinkHelp': 'Link an Admin senden',
        'user.linkCopied': 'Link kopiert',
        'user.copyLink': 'Kopieren',
        'user.share': 'Teilen',
        'user.shareLink': 'Teilen',
        'user.authRequestHelp': 'Admin-Zugriff anfordern',
        'user.authRequestShareTitle': 'IoT-Akku Autorisierung',
        'user.authRequestShareText': 'Bitte mich als Admin autorisieren',
        'common.noAuthRequests': 'Keine Anfragen gefunden',
        'user.pending': 'Ausstehend',
        'user.accepted': 'Angenommen',
        'user.rejected': 'Abgelehnt',

        'admin.authRequestReview': 'Anfrageprüfung',
        'admin.authRequestDetails': 'Anfragedetails',
        'admin.authRequestLoadError': 'Ladefehler',
        'admin.requestCode': 'Anfragecode',
        'admin.createdBy': 'Erstellt von',
        'admin.processedBy': 'Bearbeitet von',
        'admin.processedAt': 'Bearbeitet am',
        'admin.unknownUser': 'Unbekannter Nutzer',
        'admin.accept': 'Akzeptieren',
        'admin.reject': 'Ablehnen',
        'admin.authRequestAccepted': 'Anfrage akzeptiert',
        'admin.authRequestRejected': 'Anfrage abgelehnt',
        'admin.authRequestNotForAdmin': 'Nur für reguläre Nutzer relevant.',
        'admin.newsManagement': 'Nachrichtenverwaltung',
        'admin.addNews': 'Nachricht hinzufügen',
        'admin.editNews': 'Nachricht bearbeiten',
        'admin.deleteNews': 'Nachricht löschen',
        'admin.deleteNewsConfirm': 'Sind Sie sicher, dass Sie diesen Nachrichtenartikel löschen möchten?',
        'admin.newsTitle': 'Titel',
        'admin.newsSummary': 'Zusammenfassung',
        'admin.newsContent': 'Inhalt',
        'admin.newsImageUrl': 'Bild-URL',
        'admin.newsPublished': 'Veröffentlicht',
        'admin.newsDraft': 'Entwurf',
        'admin.newsStatus': 'Status',
        'admin.newsCreateSuccess': 'Nachrichtenartikel erfolgreich erstellt',
        'admin.newsUpdateSuccess': 'Nachrichtenartikel erfolgreich aktualisiert',
        'admin.newsDeleteSuccess': 'Nachrichtenartikel erfolgreich gelöscht',

        // Battery pack details
        'battery.packageDetails': 'Batteriepackdetails',
        'battery.basicInfo': 'Basisinfo',
        'battery.cellCount': 'Zellanzahl',
        'battery.tempSensorCount': 'Sensorenanzahl',
        'battery.chargeCurrentStatus': 'Ladestromstatus',
        'battery.totalVoltageStatus': 'Gesamtspannungsstatus',
        'battery.dischargeCurrentStatus': 'Entladestromstatus',
        'battery.controlStatus': 'Steuerungsstatus',
        'battery.instructionState': 'Anweisungsstatus',
        'battery.controlState': 'Steuerungsmodus',
        'battery.chargerAvailable': 'Ladegerät bereit',
        'battery.warningStatus': 'Warnungen/Fehler',
        'battery.led_warning': 'LED-Warnung',
        'battery.buzzer_warning': 'Summer-Warnung',
        'battery.freq_shift': 'Frequenzverschiebung',
        'battery.parallelStatus': 'Parallelstatus',
        'battery.parallelCount': 'Parallelanzahl',
        'battery.avgCycleCount': 'Zyklen Mittelw.',
        'battery.cycleCountUnit': 'Zyklen',

        'battery.standby': 'Standby',
        'battery.cellVoltage': 'Zellspannung',
        'battery.batteryPackUnavailable': 'Daten kurzzeitig weg, zeige letzten Stand...',
        'battery.normalStatus': 'Status normal, alles OK',
        'battery.warn_high_charge_temp': 'Hohe Ladetemperatur',

        // Dashboard
        'dashboard.soc': 'SOC',
        'dashboard.voltage': 'Gesamtspannung',
        'dashboard.current': 'Gesamtstrom',
        'dashboard.temperature': 'Höchsttemp.',
        'dashboard.systemStatus': 'Systemstatus',
        'dashboard.totalDevices': 'Geräte total',
        'dashboard.onlineDevices': 'Online',
        'dashboard.deviceStatus': 'Gerätestatus',
        'dashboard.batteryStatus': 'Batteriestatus',
        'dashboard.powerStatus': 'Leistungsstatus',
        'dashboard.temperatureStatus': 'Temperaturstatus',
        'dashboard.avgSOC': 'Durchschnitts-SOC',
        'dashboard.types': 'Typen',
        'dashboard.batteryHistory': 'Verlaufshistorie',
        'dashboard.voltageHistory': 'Spannungsverlauf',
        'dashboard.currentHistory': 'Stromverlauf',
        'dashboard.socHistory': 'SOC-Verlauf',
        'dashboard.temperatureHistory': 'Temperaturverlauf',
        'dashboard.lastHour': '1 Stunde',
        'dashboard.last6Hours': '6 Stunden',
        'dashboard.lastDay': '24 Stunden',
        'dashboard.lastWeek': 'Woche',
        'dashboard.lastMonth': 'Monat',
        'dashboard.batteryDetails': 'Batteriedetails',
        'dashboard.deviceAnalysis': 'Geräteanalyse',
        'dashboard.systemOverview': 'Systemübersicht',
        'dashboard.deviceTypeDistribution': 'Gerätetypen',
        'dashboard.voltageAndCurrentOverview': 'Spannung & Strom',
        'dashboard.onlinePercentage': 'Online-Quote',
        'dashboard.noAlerts': 'Keine Alarme',

        'dashboard.totalInstallations': 'Installationen total',
        'dashboard.viewAllInstallations': 'Alle anzeigen',
        'dashboard.activeInstallations': 'Aktive Installationen',
        'dashboard.allInstallations': 'Alle Installationen',
        'dashboard.systemAlertsNotices': 'Warnungen & Hinweise',
        'dashboard.deviceOffline': 'Gerät offline',
        'dashboard.deviceOfflineDesc': 'Gerät {{name}} ({{id}}) ist offline.',
        'dashboard.deviceAlarm': 'Gerätealarm',
        'dashboard.deviceAlarmDesc': 'Gerät {{name}} ({{id}}) hat aktive Alarme.',
        'dashboard.systemNormal': 'System normal',
        'dashboard.systemNormalDesc': 'Alle Systeme laufen einwandfrei.',

        // Installations
        'installations.loadError': 'Ladefehler der Liste',
        'installations.noInstallations': 'Keine Installationen gefunden',
        'installations.realtime': 'Echtzeit',
        'installations.oldData': 'Veraltet',
        'installations.batteries': 'Batterien',
        'installations.lastUpdate': 'Update am',
        'installations.deviceName': 'Name (optional)',
        'installations.deviceNamePlaceholder': 'Mein System',
        'installations.deviceNameHelper': 'Freundlicher Name',
        'installations.deviceIdRequired': 'ID erforderlich',
        'installations.deviceIdPlaceholder': 'ID auf WIFI-Etikett',
        'installations.deviceClaimed': 'Gerät beansprucht',
        'installations.addFailed': 'Hinzufügen fehlgeschlagen',
        'installations.otherType': 'Sonstiges',

        // Detail
        'detail.backToList': 'Zurück zur Liste',
        'detail.installationDetail': 'Installations- Details',
        'detail.installationName': 'Installationsname',
        'detail.owner': 'Besitzer',
        'detail.batteryCount': 'Batterieanzahl',
        'detail.realtimeMetrics': 'Echtzeitwerte',
        'detail.avgSOC': 'SOC Mittelw.',
        'detail.avgSOH': 'SOH Mittelw.',
        'detail.maxCellVol': 'Max. Zellspannung',
        'detail.minCellVol': 'Min. Zellspannung',
        'detail.cellVolDiff': 'Zelldifferenz',

        // Battery detail
        'battery.packDetail': 'Batteriepack #{{index}} - Details',
        'battery.packNotFound': 'Daten nicht gefunden',
        'battery.loadError': 'Ladefehler',
        'battery.packVoltage': 'Packspannung',
        'battery.packCurrent': 'Packstrom',
        'battery.packPower': 'Packleistung',
        'battery.chargerConnected': 'Ladegerät angeschlossen',
        'battery.currentLimitEnabled': 'Limit aktiv',
        'battery.fullEnergy': 'Vollkapazität',
        'battery.remainEnergy': 'Restkapazität',

        'common.yes': 'Ja',
        'common.no': 'Nein',
        'common.on': 'EIN',
        'common.off': 'AUS',
        'common.ongoing': 'Laufend',

        'battery.cellVoltages': 'Zellspannungen',
        'battery.temperatures': 'Temperaturen',
        'battery.historyTrends': 'Verlaufstrends',
        'battery.voltageCurrent': 'Spannung & Strom',
        'battery.dragToSelect': 'Bereich wählen',
        'battery.alarmDetails': 'Alarmdetails',
        'battery.noActiveAlarms': 'Keine aktiven Alarme',
        'battery.sensor': 'Sensor',
        'battery.issue': 'Problem',
        'battery.tempSensorIssues': 'Sensorprobleme',

        'battery.minCellVoltage': 'Min. Zellspannung',
        'battery.maxCellVoltage': 'Max. Zellspannung',
        'battery.mosTemp': 'MOS-Temperatur',
        'battery.envTemp': 'Umgebungstemperatur',
        'battery.otherTemps': 'Andere Temperaturen',
        'battery.noDataAvailable': 'Keine Daten',
        'battery.fetchError': 'Verlaufsfehler',
        'battery.generalError': 'Ein Fehler ist aufgetreten',

        // Settings
        'settings.recover': 'Erholung',
        'settings.delay': 'Verzögerung',
        'settings.unitV': 'Einheit: V',
        'settings.unitA': 'Einheit: A',
        'settings.unitMs': 'Einheit: ms',
        'settings.unitUs': 'Einheit: μs',
        'settings.unitC': 'Einheit: °C',
        'settings.charge': 'Laden',
        'settings.discharge': 'Entladen',
        'settings.high': 'Hoch',
        'settings.low': 'Niedrig',
        'settings.description': 'Beschreibung',
        'settings.read': 'Lesen',
        'settings.setting': 'Einstellung...',
        'settings.readSuccess': 'Erfolgreich gelesen',
        'settings.timeout': 'Zeitüberschreitung',
        'settings.operationFailed': 'Fehlgeschlagen',
        'settings.failed': 'Fehlgeschlagen',
        'settings.jkReadOnlyNote': 'JK BMS-Einstellungen werden automatisch per Broadcast aktualisiert und sind in diesem System schreibgeschützt.',
        'settings.lastUpdated': 'Zuletzt aktualisiert',
        'settings.chargeHighTemp': 'Lade-Hochtemperatur',
        'settings.dischargeHighTemp': 'Entlade-Hochtemperatur',
        'settings.designCapacity': 'Nennkapazität',
        'settings.balanceMaxCurrent': 'Max. Symmetriestrom',
        'settings.balanceTriggerDiff': 'Symmetrie-Differenz',

        'settings.mosControl': 'MOS-Steuerung',
        'settings.chargeMosControl': 'Lade-MOS',
        'settings.openChargeMos': 'Lade-MOS öffnen',
        'settings.closeChargeMos': 'Lade-MOS schließen',
        'settings.dischargeMosControl': 'Entlade-MOS',
        'settings.openDischargeMos': 'Entlade-MOS öffnen',
        'settings.closeDischargeMos': 'Entlade-MOS schließen',
        'settings.powerManagement': 'Energiemanagement',
        'settings.shutdownSleep': 'Ausschalten/Ruhe',
        'settings.opening': 'Wird geöffnet...',
        'settings.closing': 'Wird geschlossen...',
        'settings.executing': 'Wird ausgeführt...',

        'settings.protGroup1': 'Spannungsschutz',
        'settings.cellOvercharge': 'Zell-Überladung',
        'settings.cellOverchargeDesc': 'Wenn die Zellspannung den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich überschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Ladevorgang. Nach Auslösung des Schutzes wird die Ladefunktion wiederhergestellt, sobald alle Zellspannungen unter den Erholwert fallen.',
        'settings.cellOverdischarge': 'Zell-Unterladung',
        'settings.cellOverdischargeDesc': 'Wenn die Zellspannung den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich unterschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Entladevorgang. Nach Auslösung des Schutzes wird die Entladefunktion wiederhergestellt, sobald alle Zellspannungen über den Erholwert steigen.',
        'settings.totalOvercharge': 'Gesamt-Überladung',
        'settings.totalOverchargeDesc': 'Wenn die Gesamtspannung den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich überschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Ladevorgang. Nach Auslösung des Schutzes wird die Ladefunktion wiederhergestellt, sobald alle Zellspannungen unter den Erholwert fallen.',
        'settings.totalOverdischarge': 'Gesamt-Unterladung',
        'settings.totalOverdischargeDesc': 'Wenn die Gesamtspannung den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich unterschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Entladevorgang. Nach Auslösung des Schutzes wird die Entladefunktion wiederhergestellt, sobald alle Zellspannungen über den Erholwert steigen.',

        'settings.protGroup2': 'Stromschutz',
        'settings.chargeOvercurrent': 'Lade-Überstrom',
        'settings.chargeOvercurrentDesc': 'Der Warnwert ist der vom Wechselrichter angeforderte maximale Ladestrom. Wenn der Ladestrom den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich überschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Ladevorgang.',
        'settings.dischargeOvercurrent1': 'Entlade-Überstrom 1',
        'settings.dischargeOvercurrent1Desc': 'Der Warnwert ist der vom Wechselrichter angeforderte maximale Entladestrom. Wenn der Entladestrom den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich überschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Entladevorgang.',
        'settings.dischargeOvercurrent2': 'Entlade-Überstrom 2',
        'settings.dischargeOvercurrent2Desc': 'Wenn der Entladestrom den Schutzwert für die eingestellte Verzögerungszeit kontinuierlich überschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Entladevorgang.',
        'settings.shortCircuitDesc': 'Wenn für die eingestellte Verzögerungszeit ein Kurzschluss erkannt wird, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Lade- sowie Entladevorgang.',

        'settings.protGroup3': 'Temperaturschutz',
        'settings.tempHigh': 'Hochtemperaturschutz',
        'settings.tempHighDesc': 'Wenn die Temperatur den Schutzwert überschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Lade- oder Entladevorgang. Nach Auslösung des Schutzes wird die Lade- oder Entladefunktion wiederhergestellt, sobald die Temperatur unter den Erholwert fällt.',
        'settings.tempLow': 'Tieftemperaturschutz',
        'settings.tempLowDesc': 'Wenn die Temperatur den Schutzwert unterschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Lade- oder Entladevorgang. Nach Auslösung des Schutzes wird die Lade- oder Entladefunktion wiederhergestellt, sobald die Temperatur über den Erholwert steigt. Fällt die Temperatur unter den Ladewarnwert, schaltet sich die Heizfunktion automatisch ein. Steigt die Temperatur auf den Ladeerholwert, schaltet sich die Heizfunktion automatisch aus.',
        'settings.mosTempHigh': 'MOS-Übertemperatur',
        'settings.mosTempHighDesc': 'Wenn die MOS-Temperatur höher als der Schutzwert ist, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Lade- sowie Entladevorgang. Nach Auslösung des Schutzes wird die Lade- oder Entladefunktion wiederhergestellt, sobald die MOS-Temperatur unter den Erholwert fällt.',
        'settings.envTemp': 'Umgebungstemperaturschutz',
        'settings.envTempDesc': 'Wenn die Umgebungstemperatur den Hochtemperaturschutzwert überschreitet oder den Tieftemperaturschutzwert unterschreitet, löst das BMS sofort die Schutzmaßnahme aus und stoppt den Lade- oder Entladevorgang. Nach Auslösung des Schutzes wird die Lade- oder Entladefunktion automatisch wiederhergestellt, sobald die Umgebungstemperatur wieder in den entsprechenden Erholtemperaturbereich zurückkehrt.',

        'settings.enableProtection': 'Schutz aktivieren',
        'settings.chargeTempProt': 'Ladetemp.-Schutz',
        'settings.dischargeTempProt': 'Entladetemp.-Schutz',

        'settings.historyManagement': 'Verlaufsverwaltung',
        'settings.reading': 'Wird gelesen...',
        'settings.readHistory': 'Alle logs lesen (1-40)',
        'settings.stopReading': 'Lese-Stopp',
        'settings.clearHistory': 'Logs löschen',
        'settings.messages.historyReadComplete': 'Fertig! {{count}} Logs gelesen',
        'settings.historyRecords': 'Verlaufseinträge ({{count}})',
        'settings.record': 'Eintrag {{index}}',
        'settings.timeUnknown': 'Unbekannte Zeit',
        'settings.cellInfo': 'Zellinfo ({{count}} Zellen)',
        'settings.tempSensors': 'Sensoren ({{count}})',
        'settings.statusInfo': 'Statusinfo',
        'settings.noHistoryFound': 'Keine Einträge',
        'settings.clearHistoryResult': 'Löschresultat',
        'settings.confirmClearHistory': 'Löschen bestätigen',
        'settings.confirmClearHistoryDesc': 'Sind Sie sicher, dass Sie alle Verlaufsdaten aus dem BMS löschen möchten?',
        'settings.clearHistoryWarning': 'Dieser Vorgang löscht unwiderruflich alle im BMS-Gerät gespeicherten Verlaufsprotokolle. Diese Daten können nicht wiederhergestellt werden.',
        'settings.confirmDelete': 'Löschen bestätigen',

        'settings.inverterProtocolConfig': 'Protokoll-Konfiguration',
        'settings.maxChargeCurrent': 'Lade­stromgrenzwert',
        'settings.maxChargeCurrentDesc': 'Der Lade­stromgrenzwert (CCL, Charge Current Limit) bezeichnet den maximal zulässigen Ladestrom, den ein einzelnes Batteriemodul unter normalen Betriebsbedingungen an den Wechselrichter meldet. Wenn N Batteriemodule parallel betrieben werden, entspricht der vom Batteriesystem beim Wechselrichter angeforderte maximale Gesamtladestrom der Summe der einzelnen CCL-Werte, also CCL × N. \nDer Schutzwert bezeichnet den Stromschwellenwert, bei dem ein einzelnes Batteriemodul den Überstromschutz auslöst. Der CCL muss kleiner als der Schutzwert sein.',
        'settings.maxDischargeCurrent': 'Entladestromgrenzwert',
        'settings.maxDischargeCurrentDesc': 'Der Entladestromgrenzwert (DCL, Discharge Current Limit) bezeichnet den maximal zulässigen Entladestrom, den ein einzelnes Batteriemodul unter normalen Betriebsbedingungen an den Wechselrichter meldet. Wenn N Batteriemodule parallel betrieben werden, entspricht der vom Batteriesystem beim Wechselrichter angeforderte maximale Gesamtentladestrom der Summe der einzelnen DCL-Werte, also DCL × N. \nDer Schutzwert bezeichnet den Stromschwellenwert, bei dem ein einzelnes Batteriemodul den Überstromschutz auslöst. Der DCL muss kleiner als der Schutzwert sein.',
        'settings.maxChargeVoltage': 'Ladespannungsgrenzwert',
        'settings.maxChargeVoltageDesc': 'Der Lade­spannungsgrenzwert (CVL, Charge Voltage Limit) ist die vom Batteriesystem beim Wechselrichter angeforderte maximale Gesamtspannung.',
        'settings.chargeVoltageLimitV': 'CVL (V)',
        'settings.chargeCurrentLimitA': 'CCL (A)',
        'settings.dischargeCurrentLimitA': 'DCL (A)',
        'settings.protocolSelectDesc': 'Wähle das passende Protokoll für deinen Wechselrichter.',
        'settings.canProtocol': 'CAN-Protokoll',
        'settings.rs485Protocol': 'RS485-Protokoll',
        'settings.selectCanProtocol': 'CAN wählen',
        'settings.selectRs485Protocol': 'RS485 wählen',

        'settings.mainBatterySettings': 'Hauptbatterie-Einstellungen',
        'settings.systemConfig': 'Batteriekonfiguration',
        'settings.otherConfig': 'Andere Einstellungen',
        'settings.timeSettings': 'Zeiteinstellungen',
        'settings.timeSettingsDesc': 'Interne Zeit des BMS, die zur Anzeige und Aufzeichnung von Daten verwendet wird. Die Synchronisierung mit der lokalen Zeit erleichtert die Nachverfolgung der Daten.',
        'settings.syncTime': 'PC-Zeit sync',
        'settings.bmsTime': 'BMS-Zeit',
        'settings.capacitySettings': 'Kapazitätseinstellungen',
        'settings.capacitySettingsDesc': 'Die Änderung der Restkapazität wirkt sich auf die SOC-Prozentanzeige aus. Die Nennkapazität ist die werkseitige Kapazität der Batterie, und die Vollkapazität gibt die aktuelle tatsächliche Kapazität an, die mit der Nutzungsdauer und der Zyklenzahl abnimmt.',
        'settings.balance': 'Aktive Balancierungseinstellungen',
        'settings.balanceDesc': 'Startspannung für aktive Symmetrierung einstellen. Die Symmetrierung beginnt, wenn die Zellspannung über der Startspannung liegt, und endet, wenn sie darunter fällt.',
        'settings.balanceStartVoltage': 'Startspannung',
        'settings.balanceStartDiff': 'Startdifferenz',
        'settings.balanceStartVoltageMv': 'Startspannung (mV)',
        'settings.balanceStartDiffMv': 'Startdifferenz (mV)',

        // JK BMS Einstellungsblock-Titel und Felder
        'settings.temperatureHighProtection': 'Hochtemperaturschutz',
        'settings.temperatureLowProtection': 'Tieftemperaturschutz',
        'settings.mosTempHighProtection': 'MOS-Hochtemperaturschutz',
        'settings.balanceParams': 'Balancierungsparameter',
        'settings.protection': 'Schutz',
        'settings.chargeLowTemp': 'Lade-Tieftemp.',
        'settings.dischargeLowTemp': 'Entlade-Tieftemp.',

        'common.enabled': 'Aktiviert',

        // JK BMS Einstellungen - Pack-Spannungsschutz
        'jk.noSettingsData': 'Noch keine Einstellungsdaten empfangen. Einstellungen werden aktualisiert, wenn das BMS einen SETUP-Frame sendet.',
        'jk.chargeVoltages': 'Ladespannungen',
        'jk.socSettings': 'SOC-Einstellungen',
        'jk.packVoltageProtection': 'Pack-Spannungsschutz',
        'jk.packOVP': 'Float-Spannung',
        'jk.packUVP': 'Max. Wechselrichter-Ladespannung',
        'jk.floatVoltage': 'Float-Spannung',
        'jk.inverterMaxChargeVoltage': 'Max. Wechselrichter-Ladespannung',
        'jk.soc100Voltage': 'SOC 100% Spannung',
        'jk.soc0Voltage': 'SOC 0% Spannung',
        'jk.smartSleepVoltage': 'Smart-Sleep-Spannung',
        'jk.autoPowerOffVoltage': 'Auto-Abschaltspannung',
        // JK BMS Einstellungen - Stromschutz
        'jk.currentProtection': 'Stromschutz',
        'jk.chargeOC': 'Ladestromgrenze',
        'jk.chargeOCPDelay': 'Lade-ÜSS Verzögerung',
        'jk.chargeOCPRelease': 'Lade-ÜSS Freigabe',
        'jk.dischargeOC': 'Entladestromgrenze',
        'jk.dischargeOCPDelay': 'Entlade-ÜSS Verzögerung',
        'jk.dischargeOCPRelease': 'Entlade-ÜSS Freigabe',
        'jk.scpRelease': 'Kurzschlussschutz-Freigabe',
        // JK BMS Einstellungen - Batteriekonfiguration
        'jk.batteryConfig': 'Batteriekonfiguration',
        'jk.cellCount': 'Zellanzahl',
        'jk.chargeSwitch': 'Ladeschalter',
        'jk.dischargeSwitch': 'Entladeschalter',
        'jk.balanceSwitch': 'Balancierungsschalter',
        'jk.scpDelay': 'Kurzschlussschutz-Verzögerung',
        // JK BMS Einstellungen - Gerätekonfiguration
        'jk.deviceConfig': 'Gerätekonfiguration',
        'jk.deviceAddress': 'Geräteadresse',
        'jk.prechargeDelay': 'Vorladeverzögerung',
        'jk.smartSleepTime': 'Smart-Sleep-Zeit',
        'jk.heatEnabled': 'Heizfunktion',
        'jk.tempSensorDisabled': 'Tempsensor deaktiviert',
        'jk.gpsHeartbeat': 'GPS-Heartbeat',
        'jk.portSwitch': 'Port (RS485)',
        'jk.lcdAlwaysOn': 'LCD immer an',
        'jk.specialCharger': 'Spezialladegerät',
        'jk.smartSleepEnabled': 'Smart Sleep',
        'jk.disablePCLModule': 'PCL-Modul deaktiviert',
        'jk.timedStoredData': 'Zeitgest. Datenspeicherung',
        'jk.chargingFloatMode': 'Erhaltungsladung',

        'settings.batterySeries': 'Zellenanzahl',
        'settings.batterySeriesDesc': 'Die standardmäßige Zellenanzahl des Systems ist 16. Wenn die tatsächliche Anzahl der Zellen weniger als 16 beträgt, passen Sie diese hier an den entsprechenden tatsächlichen Wert an.',
        'settings.batterySeriesHelper': 'Serielle Zellen',
        'settings.cycleCount': 'Zyklenstand',
        'settings.cycleCountDesc': 'Die Zyklenzahl summiert sich automatisch während der Lade- und Entladevorgänge der Batterie auf und kann hier manuell angepasst werden.',
        'settings.cycleCountHelper': 'Lade/Entladezyklen',
        'settings.fullChargeParams': 'Voll-Ladeparameter',
        'settings.fullChargeParamsDesc': 'Bedingungen für die Voll-Ladung festlegen. Wenn Batteriespannung und -strom gleichzeitig die Abschaltbedingungen erfüllen, bestimmt das BMS, dass die Batterie vollständig geladen ist. Der Alarm bei niedriger Kapazität dient zur Einstellung des SOC-Schwellwerts für Warnmeldungen bei geringem Ladestand.',
        'settings.fullChargeCutoffVoltage': 'Abschaltspannung (V)',
        'settings.fullChargeCutoffCurrent': 'Abschaltstrom (A)',
        'settings.lowCapacityAlarm': 'Niedrig-Akku Alarm (%)',
        'settings.capacityRelease': 'Kapazitätsfreigabe',
        'settings.capacityReleaseDesc': 'Befehl setzen (Set): A5\nLegen Sie den SOC-Schwellwert für die Kapazitätsfreigabe fest.',
        'settings.socValue': 'SOC Wert (%)',
        'settings.socRange': 'Bereich: 74-97',

        'settings.currentZero': 'Nullpunkt-Kalibrierung',
        'settings.currentZeroDesc': 'Befehl: AA\nKalibrieren Sie den Nullpunkt des Stromsensors, wenn kein Strom fließt. Ein Korrekturwert kann eingegeben werden (Standard ist 0).',
        'settings.correctionValue': 'Korrekturwert (0.1A)',
        'settings.refVoltage': 'Referenzspannungs-Kalibrierung',
        'settings.refVoltageDesc': 'Befehl: A9\nKalibrieren Sie die Referenzspannung des Batteriepacks (bezieht sich normalerweise auf die Referenz der Zellspannungsmessung). Geben Sie den gemessenen tatsächlichen Spannungswert ein (mV).',
        'settings.actualVoltageMv': 'Tatsächliche Spannung (mV)',
        'settings.totalVoltage': 'Gesamtspannungs-Kalibrierung',
        'settings.totalVoltageDesc': 'Geben Sie hier die tatsächliche Batteriespannung ein, die mit einem Multimeter oder einem anderen Messgerät gemessen wurde. Dieser Wert kann zur Kalibrierung des vom BMS angezeigten Spannungswerts verwendet werden.',
        'settings.actualTotalVoltageMv': 'Tatsächliche Gesamtspannung (mV)',
        'settings.chargeCurrent': 'Ladestrom-Kalibrierung',
        'settings.chargeCurrentDesc': 'Befehl: AC\nKalibrieren Sie den Ladestrom. Geben Sie den tatsächlich gemessenen Ladestromwert ein (A). Das System konvertiert diesen automatisch in 0,1A Einheiten.',
        'settings.actualCurrentA': 'Tatsächlicher Strom (A)',
        'settings.dischargeCurrent': 'Entladestrom-Kalibrierung',
        'settings.dischargeCurrentDesc': 'Befehl: AB\nKalibrieren Sie den Entladestrom. Geben Sie den tatsächlich gemessenen Entladestromwert ein (A). Das System konvertiert diesen automatisch in 0,1A Einheiten.',
        'settings.systemInfo': 'Systeminfo',
        'settings.versionInfo': 'Version',
        'settings.versionInfoDesc': 'BMS Firmware.',
        'settings.internalVersion': 'Firmware-Version',
        'settings.internalVersionHelper': 'Interne Version',
        'settings.restoreDefault': 'Werkseinstellungen',
        'settings.restoreDefaultDesc': 'Alles auf Standard zurücksetzen.',
        'settings.restoreDefaultBtn': 'Standard herstellen',
        'settings.restoring': 'Wird wiederhergestellt...',

        'settings.permissionsDesc': 'Berechtigungen für diese Installation verwalten.',
        'settings.shareSuccess': 'Geteilt mit {{email}}',
        'settings.shareFailed': 'Teilen der Installation fehlgeschlagen',
        'settings.removeAccessSuccess': 'Zugriff entfernt',
        'settings.removeAccessFailed': 'Fehler beim Entfernen',
        'settings.loadingUsers': 'Nutzer laden...',
        'settings.noSharedUsers': 'Keine geteilten Nutzer.',
        'settings.noPermission': 'Sie haben keine Berechtigung, diese Installation zu verwalten. Nur der Besitzer kann die Installation teilen.',
        'settings.userEmail': 'E-Mail',
        'settings.accessLevel': 'Level',
        'settings.readOnly': 'Nur Lesen',
        'settings.readWrite': 'Lesen & Schreiben',
        'settings.sharing': 'Wird geteilt...',
        'settings.shareDevice': 'Installation teilen',
        'settings.usersWithAccess': 'Nutzer mit Zugriff',
        'settings.remove': 'Entfernen',

        'settings.modificationLog': 'Eingriffshistorie',
        'settings.loadHistoryFailed': 'Ladefehler',
        'settings.noChangesFound': 'Keine Änderungen',
        'settings.logSetting': 'Einstellungspunkt',
        'settings.na': 'N/V',

        'settings.enabled': 'Aktiviert',
        'settings.controlMode': 'Steuermodus',
        'settings.delayMs': 'Verzögerung (ms)',
        'settings.unknown': 'Unbekannt',
        'settings.alarmVoltage': 'Alarm (mV)',
        'settings.chargeAlarmVoltage': 'Ladealarm (mV)',
        'settings.dischargeAlarmVoltage': 'Entladealarm (mV)',
        'settings.protectionVoltage': 'Schutz (mV)',
        'settings.recoveryVoltage': 'Erholung (mV)',
        'settings.alarmVoltageV': 'Alarm (V)',
        'settings.protectionVoltageV': 'Schutz (V)',
        'settings.recoveryVoltageV': 'Erholung (V)',
        'settings.alarmCurrentA': 'Alarm (A)',
        'settings.protectionCurrentA': 'Schutz (A)',
        'settings.recoveryCurrentA': 'Erholung (A)',
        'settings.chargeProtectionCurrentA': 'Ladeschutz (A)',
        'settings.delayUs': 'Verzögerung (μs)',
        'settings.alarmCurrentMa': 'Alarm (mA)',
        'settings.protectionCurrentMa': 'Schutz (mA)',
        'settings.recoveryCurrentMa': 'Erholung (mA)',
        'settings.alarmTemp': 'Alarm (°C)',
        'settings.protectionTemp': 'Schutz (°C)',
        'settings.recoveryTemp': 'Erholung (°C)',
        'settings.chargeHighTempAlarm': 'Lade-Hochtemperatur Alarm (°C)',
        'settings.chargeHighTempProtection': 'Lade-Hochtemperatur Schutz (°C)',
        'settings.chargeHighTempRecovery': 'Lade-Hochtemperatur Erholung (°C)',
        'settings.dischargeHighTempAlarm': 'Entlade-Hochtemperatur Alarm (°C)',
        'settings.dischargeHighTempProtection': 'Entlade-Hochtemperatur Schutz (°C)',
        'settings.dischargeHighTempRecovery': 'Entlade-Hochtemperatur Erholung (°C)',
        'settings.chargeLowTempAlarm': 'Lade-Tieftemperatur Alarm (°C)',
        'settings.chargeLowTempProtection': 'Lade-Tieftemperatur Schutz (°C)',
        'settings.chargeLowTempRecovery': 'Lade-Tieftemperatur Erholung (°C)',
        'settings.dischargeLowTempAlarm': 'Entlade-Tieftemperatur Alarm (°C)',
        'settings.dischargeLowTempProtection': 'Entlade-Tieftemperatur Schutz (°C)',
        'settings.dischargeLowTempRecovery': 'Entlade-Tieftemperatur Erholung (°C)',
        'settings.envHighTempAlarm': 'Umgebungs-Hochtemp Alarm (°C)',
        'settings.envHighTempProtection': 'Umgebungs-Hochtemp Schutz (°C)',
        'settings.envHighTempRecovery': 'Umgebungs-Hochtemp Erholung (°C)',
        'settings.envLowTempAlarm': 'Umgebungs-Tieftemp Alarm (°C)',
        'settings.envLowTempProtection': 'Umgebungs-Tieftemp Schutz (°C)',
        'settings.envLowTempRecovery': 'Umgebungs-Tieftemp Erholung (°C)',
        'settings.socPercent': 'SOC (%)',

        'settings.fullCharge': 'Voll-Ladung',
        'settings.cellSleep': 'Ruhemodus',
        'settings.inverterProtocol': 'Protokoll',

        'settings.title': 'Installations- Einstellungen',
        'settings.sendCommandFailed': 'Befehlsfehler',
        'settings.confirmShutdown': 'Herunterfahren/Schlafmodus bestätigen',
        'settings.confirmShutdownDesc': 'Sind Sie sicher, dass Sie die Batterie ausschalten oder in den Schlafmodus versetzen möchten? Nach dem Ausschalten müssen Sie zum Batterieinstallationsort gehen, um sie manuell zu starten.',

        'settings.tabs.control': 'Steuerung',
        'settings.tabs.protection': 'Schutzeinstellungen',
        'settings.tabs.protocol': 'Protokolleinstellungen',
        'settings.tabs.system': 'Systemeinstellungen',
        'settings.tabs.log': 'Einstellungsprotokoll',

        'settings.messages.fetchingProtocolSettings': 'Lade Protokolldaten...',
        'settings.messages.fetchProtocolListFailed': 'Ladefehler Protokollliste',
        'settings.messages.fetchingHistory': 'Lese Logs...',
        'settings.messages.startReadingHistory': 'Starte Log-Lesen...',
        'settings.messages.readingHistoryProgress': 'Lese {{current}}/{{total}}...',
        'settings.messages.protocolSetSuccess': 'Protokoll erfolgreich eingestellt',
        'settings.messages.protocolListSuccess': 'Protokollliste erfolgreich abgerufen',
        'settings.messages.protocolListComplete': 'Protokolllistenabruf abgeschlossen! {{count}} Protokolle gefunden',
        'settings.messages.protocolListCompleteCan': 'Erfolg! {{count}} CAN-Protokolle',
        'settings.messages.fetchingProtocolIds': 'Lade IDs...',
        'settings.messages.fetchingCanNames': 'CAN-Namen laden...',
        'settings.messages.fetchingRs485Names': 'RS485-Namen laden...',

        'support.title': 'Technischer Support',
        'support.newPost': 'Neuer Post',
        'support.editPost': 'Bearbeiten',
        'support.searchPlaceholder': 'Suchen...',
        'support.filterByTag': 'Tag-Filter',
        'support.allTags': 'Alle Tags',
        'support.products': 'Produkte',
        'support.categories': 'Kategorien',
        'support.sortBy': 'Sortieren',
        'support.sortLatest': 'Neueste',
        'support.sortPopular': 'Beliebt',
        'support.sortUnsolved': 'Ungelöst',
        'support.sortMostViewed': 'Gefiltert',
        'support.loadError': 'Ladefehler',
        'support.noSearchResults': 'Keine Treffer',
        'support.noPosts': 'Keine Posts',
        'support.createFirstPost': 'Ersten Post erstellen',
        'support.minutesAgo': 'vor {{count}} Min.',
        'support.hoursAgo': 'vor {{count}} Std.',
        'support.daysAgo': 'vor {{count}} Tagen',
        'support.pinned': 'Angeheftet',
        'support.locked': 'Gesperrt',
        'support.resolved': 'Gelöst',
        'support.private': 'Privat',
        'support.views': 'Aufrufe',
        'support.replies': 'Antworten',
        'support.noReplies': 'Keine Antworten',
        'support.backToList': 'Liste',
        'support.postNotFound': 'Post weg',
        'support.accessDenied': 'Zugriff verweigert',
        'support.addReply': 'Antworten',
        'support.replyPlaceholder': 'Text eingeben...',
        'support.submitReply': 'Antworten',
        'support.loginToReply': 'Einloggen zum Antworten',
        'support.postLocked': 'Gesperrt',
        'support.bestAnswer': 'Beste Antwort',
        'support.markBestAnswer': 'Als beste Antwort markieren',
        'support.unmarkBestAnswer': 'Markierung entfernen',
        'support.confirmDelete': 'Löschen?',
        'support.confirmDeletePost': 'Diesen Post wirklich löschen?',
        'support.confirmDeleteReply': 'Diese Antwort löschen?',
        'support.pin': 'Anheften',
        'support.unpin': 'Lösen',
        'support.lock': 'Sperren',
        'support.unlock': 'Entsperren',
        'support.statusOpen': 'Ungelöst',
        'support.statusResolved': 'Gelöst',
        'support.statusClosed': 'Zu',
        'support.postTitle': 'Titel',
        'support.titlePlaceholder': 'Problem kurz beschreiben',
        'support.postContent': 'Inhalt',
        'support.contentPlaceholder': 'Details hier...',
        'support.selectProduct': 'Produkt wählen',
        'support.noProduct': 'Keins',
        'support.selectCategory': 'Kategorie wählen',
        'support.categoryRequired': 'Kategorie wählen!',
        'support.announcementAdminOnly': 'Nur Admins.',
        'support.titleContentRequired': 'Titel/Inhalt fehlen',
        'support.linkDevice': 'Gerät verknüpfen',
        'support.linkDeviceDescription': 'Hilft bei der Diagnose.',
        'support.selectDevice': 'Gerät wählen',
        'support.noDevice': 'Keins',
        'support.packIndex': 'Akku-Index',
        'support.linkedDevice': 'Verknüpft',
        'support.linkedDeviceSnapshot': 'Schnappschuss',
        'support.publicPost': 'Öffentlich',
        'support.privatePost': 'Privat',
        'support.publicDescription': 'Jeder kann diesen Beitrag sehen',
        'support.privateDescription': 'Nur Sie und die Administratoren können diesen Beitrag sehen',
        'support.submitPost': 'Posten',
        'support.saveDraft': 'Entwurf speichern',
        'support.draftSaved': 'Gespeichert',
        'support.similarPostsFound': 'Ähnliche Posts:',
        'support.createError': 'Fehler beim Erstellen',

        'support.myPosts': 'Meine Posts',
        'support.myPostsTab': 'Meine Posts',
        'support.draftsTab': 'Entwürfe',
        'support.noMyPosts': 'Nichts gepostet.',
        'support.untitledDraft': 'Ohne Titel',
        'support.lastSaved': 'Zuletzt am',
        'support.continueDraft': 'Weiter bearbeiten',
        'support.deleteDraft': 'Löschen',
        'support.noDrafts': 'Keine Entwürfe',
        'support.addImages': 'Bilder',
        'support.maxFilesError': 'Max. {{max}} Bilder',
        'support.onlyImagesAllowed': 'Nur Bilder erlaubt',
        'support.fileTooLarge': 'Datei zu groß (10MB)',
        'support.uploadFailed': 'Ladefehler',
        'common.uploadImages': 'Bilder hochladen',
        'support.mentioning': 'Erwähnung',

        'support.adminPanel': 'Support-Verwaltung',
        'support.tagsTab': 'Tags',
        'support.templatesTab': 'Vorlagen',
        'support.reportsTab': 'Meldungen',
        'support.addTag': 'Tag hinzufügen',
        'support.editTag': 'Tag bearbeiten',
        'support.tagType': 'Typ',
        'support.tagColor': 'Farbe',
        'support.confirmDeleteTag': 'Tag löschen?',
        'support.addTemplate': 'Vorlage hinzufügen',
        'support.editTemplate': 'Vorlage bearbeiten',
        'support.templateContent': 'Inhalt',
        'support.templatePreview': 'Vorschau',
        'support.templatePlaceholder': 'Markdown unterstützt...',
        'support.noTemplates': 'Keine Vorlagen',
        'support.confirmDeleteTemplate': 'Vorlage löschen?',
        'support.useTemplate': 'Verwenden',
        'support.loadTemplatesError': 'Fehler beim Laden',
        'support.filterStatus': 'Filter',
        'support.reportedContent': 'Gemeldeter Inhalt',
        'support.reportReason': 'Grund',
        'support.reporter': 'Reporter',
        'support.reportPending': 'Warten',
        'support.reportReviewed': 'Geprüft',
        'support.reportDismissed': 'Verworfen',
        'support.markReviewed': 'Geprüft setzen',
        'support.dismissReport': 'Verwerfen',
        'support.noReports': 'Keine Meldungen',
        'support.linkedDeviceSettings': 'Momentaufnahme der Einstellungen',

        // API Keys
        'apiKeys.menuTitle': 'API-Schlüssel',
        'apiKeys.title': 'API-Schlüssel',
        'apiKeys.description': 'Zugangsschlüssel für Integrationen von Drittanbietern verwalten',
        'apiKeys.usageWarning': 'Verwenden Sie API-Schlüssel, um externe Anwendungen wie Home Assistant oder Grafana zu authentifizieren, ohne sich anmelden zu müssen. Halten Sie Ihre Schlüssel geheim!',
        'apiKeys.myKeys': 'Meine Schlüssel',
        'apiKeys.generateKey': 'Schlüssel generieren',
        'apiKeys.keyName': 'Name',
        'apiKeys.created': 'Erstellt',
        'apiKeys.lastUsed': 'Zuletzt verwendet',
        'apiKeys.noKeys': 'Keine API-Schlüssel gefunden',
        'apiKeys.integrationExamples': 'Integrationsbeispiele',
        'apiKeys.haTitle': 'Home Assistant (REST-Sensor)',
        'apiKeys.haInstructions': 'Fügen Sie dies zu Ihrer configuration.yaml hinzu:',
        'apiKeys.curlTitle': 'cURL / Terminal',
        'apiKeys.generateDialogTitle': 'API-Schlüssel generieren',
        'apiKeys.keyNameLabel': 'Schlüsselname (z. B. Home Assistant)',
        'apiKeys.generateAction': 'Generieren',
        'apiKeys.successDialogTitle': 'API-Schlüssel generiert',
        'apiKeys.copyWarning': 'Kopieren Sie diesen Schlüssel jetzt. Sie werden ihn nicht mehr sehen können!',
        'apiKeys.createError': 'Erstellen fehlgeschlagen',
        'apiKeys.deleteError': 'Löschen fehlgeschlagen',
        'apiKeys.loadError': 'Laden fehlgeschlagen',

        // Einstellungen
        'settings.deleteAccount': 'Konto löschen',
        'settings.deleteAccountDesc': 'Sobald Sie Ihr Konto löschen, gibt es kein Zurück mehr. Bitte seien Sie sicher.',
        'settings.deleteAccountConfirm': 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
        'settings.deleteAccountWarning': 'Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden.',
        'settings.deleteAccountSuccess': 'Konto erfolgreich gelöscht',
    },
};

export default de;
